module.exports = __webpack_public_path__ + "img/notapply.067b87a9.svg";